import React from "react";

export default function Instagram({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40.068"
      height="40.555"
      viewBox="0 0 40.068 40.555"
      className={className}
    >
      <path
        id="Path_303"
        data-name="Path 303"
        d="M1027.49,8258.555a20.13,20.13,0,0,1-19.98-20.341,22.284,22.284,0,0,1,.156-2.506,20.054,20.054,0,1,1,19.815,22.847Zm-11.665-20.386c0,1.652-.018,3.3.009,4.948a6.94,6.94,0,0,0,6.618,7.006c3.386.136,6.78.126,10.166.009a6.978,6.978,0,0,0,6.672-6.97q.081-4.89,0-9.777a7.018,7.018,0,0,0-6.762-7.033q-4.943-.151-9.9,0a7,7,0,0,0-6.789,7.132c-.027,1.563,0,3.124,0,4.686Z"
        transform="translate(-1007.51 -8218)"
        fill="currentColor"
      />
      <path
        id="Path_304"
        data-name="Path 304"
        d="M1028.657,8248.972c-1.544,0-3.088.026-4.632,0a4.748,4.748,0,0,1-4.821-4.821q-.108-4.753,0-9.507a4.709,4.709,0,0,1,4.686-4.83c3.214-.091,6.437-.091,9.651.009a4.731,4.731,0,0,1,4.632,4.876c.036,3.123.045,6.247,0,9.38a4.778,4.778,0,0,1-4.884,4.894c-1.544.026-3.088.008-4.632.008Zm5.869-9.525a5.761,5.761,0,1,0-5.805,5.823A5.743,5.743,0,0,0,1034.526,8239.446Zm2.338-6.355c-.912-.632-1.4-1.21-1.959-1.292a1.348,1.348,0,1,0,.081,2.69c.56-.116,1.011-.722,1.887-1.4Z"
        transform="translate(-1008.641 -8219.142)"
        fill="currentColor"
      />
      <path
        id="Path_305"
        data-name="Path 305"
        d="M1029.425,8236.33a3.719,3.719,0,0,1,3.648,3.782,3.658,3.658,0,1,1-7.313-.153,3.727,3.727,0,0,1,3.665-3.629Z"
        transform="translate(-1009.283 -8219.781)"
        fill="currentColor"
      />
    </svg>
  );
}
